import '../styles/pages/legal.css'

function CookiePolicy() {
  return (
    <div className="legal-page">
      <div className="legal-content">
        <h1>Cookiepolitik</h1>
        <p className="last-updated">Sidst opdateret: {new Date().toLocaleDateString('da-DK')}</p>

        <section>
          <h2>1. Hvad Er Cookies?</h2>
          <p>
            Cookies er små tekstfiler der gemmes på din enhed når du besøger en website. 
            De hjælper websitet med at huske dine præferencer og forbedre din oplevelse.
          </p>
        </section>

        <section>
          <h2>2. Cookies Vi Bruger</h2>
          
          <h3>2.1 Nødvendige Cookies</h3>
          <p>
            Disse cookies er nødvendige for at tjenesten kan fungere. De kræver ikke samtykke:
          </p>
          <ul>
            <li><strong>Session cookies:</strong> Holder dig logget ind under din session</li>
            <li><strong>Security cookies:</strong> Beskytter mod sikkerhedstrusler</li>
          </ul>

          <h3>2.2 Funktionelle Cookies</h3>
          <p>
            Disse cookies forbedrer funktionaliteten, men tjenesten kan fungere uden dem:
          </p>
          <ul>
            <li><strong>Preference cookies:</strong> Husker dine valg (fx sprog, tema)</li>
            <li><strong>Analytics cookies:</strong> Hjælper os med at forstå hvordan tjenesten bruges (anonymiseret)</li>
          </ul>

          <h3>2.3 Marketing Cookies</h3>
          <p>
            Vi bruger <strong>ikke</strong> marketing cookies eller tracking cookies fra tredjeparter.
          </p>
        </section>

        <section>
          <h2>3. Tredjeparts Cookies</h2>
          <p>
            Vi bruger følgende tredjeparts services der kan sætte cookies:
          </p>
          <ul>
            <li><strong>Stripe:</strong> For betalingshåndtering (kun hvis du vælger Premium)</li>
          </ul>
          <p>
            Disse services har deres egne cookiepolitikker. Se Stripe's <a href="https://stripe.com/dk/privacy" target="_blank" rel="noopener noreferrer">privatlivspolitik</a>.
          </p>
        </section>

        <section>
          <h2>4. Hvordan Man Håndterer Cookies</h2>
          <h3>4.1 Via Browser Indstillinger</h3>
          <p>
            Du kan kontrollere cookies via dine browser indstillinger. De fleste browsere tillader dig at:
          </p>
          <ul>
            <li>Se hvilke cookies der er gemt</li>
            <li>Slette cookies</li>
            <li>Blokere cookies fra specifikke websites</li>
            <li>Blokere alle cookies</li>
          </ul>
          <p>
            <strong>Bemærk:</strong> Hvis du blokerer alle cookies, kan nogle funktioner på Parkort ikke fungere korrekt.
          </p>

          <h3>4.2 Via Cookie Consent Banner</h3>
          <p>
            Når du første gang besøger Parkort, kan du vælge hvilke cookies du accepterer. 
            Du kan altid ændre dine valg senere.
          </p>
        </section>

        <section>
          <h2>5. Do Not Track (DNT)</h2>
          <p>
            Vi respekterer "Do Not Track" signaler fra din browser. Hvis DNT er aktiveret, 
            vil vi ikke sætte ikke-nødvendige cookies.
          </p>
        </section>

        <section>
          <h2>6. Opdateringer</h2>
          <p>
            Vi kan opdatere denne cookiepolitik fra tid til anden. Væsentlige ændringer vil blive kommunikeret 
            via en notifikation på hjemmesiden.
          </p>
        </section>

        <section>
          <h2>7. Kontakt</h2>
          <p>
            Hvis du har spørgsmål til vores brug af cookies, kontakt os på:<br />
            <strong>Email:</strong> <a href="mailto:info@thomasvalenzuela.com">info@thomasvalenzuela.com</a>
          </p>
        </section>
      </div>
    </div>
  )
}

export default CookiePolicy
